import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

import GithubIcon from './icon_gh.svg';
import DownloadIcon from './icon_dwnl.svg';
import QuickstartIcon from './icon_qs.svg';
import ReferenceIcon from './icon_ref.svg';

const Entry = ({
  title,
  name,
  description,
  url: quickstartUrl,
  sdk: {
    logo,
    url: sdkUrl,
    referenceUrl
  },
  defaultArticle: {
    githubSampleLink
  } = {}
}) => (
  <li id={name} className={styles.entry}>
    <div className={styles.titleset}>
      <div className={styles.logo}>
        <img src={`/docs/img/library/${logo}.svg`} alt="sdk logo" />
      </div>
      <div className={styles.title}>{title}</div>
    </div>
    <div className={styles.description}>
      {description}
    </div>
    <ul className={styles.links}>
      <li><a href={sdkUrl}><GithubIcon /><span>Github</span></a></li>
      {githubSampleLink &&
        <li><a href={githubSampleLink}><DownloadIcon /><span>Sample App</span></a></li>
      }
      {quickstartUrl &&
        <li><a href={quickstartUrl}><QuickstartIcon /><span> Quickstart</span></a></li>
      }
      {referenceUrl &&
        <li><a href={referenceUrl}><ReferenceIcon /><span> Documentation</span></a></li>
      }
    </ul>
  </li>
);

Entry.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  sdk: PropTypes.shape({
    logo: PropTypes.string,
    url: PropTypes.string,
    referenceUrl: PropTypes.string
  }),
  defaultArticle: PropTypes.shape({
    githubSampleLink: PropTypes.string
  })
};

export default Entry;
